import type React from 'react'
import type { ILabelGroupTemplate3MaxLabels6Props } from 'blocks/LabelGroup/Templates'
import type { ITVShowPopupProps } from 'blocks/Popup/Templates'
import type { IMultiColumnsItemProps } from '../../MultiColumnsItem'

import { TextBoxMaxLine4Body3 } from 'atoms/TextBox/Templates'
import { LabelGroupTemplate3MaxLabels6 } from 'blocks/LabelGroup/Templates'
import { TextBlockWithMore } from 'blocks/TextBlock/Templates'
import { MultiColumnsRowGap } from '../../MultiColumns.h'
import { MultiColumnsItem } from '../../MultiColumnsItem'

export interface ILabelsGroupDescription4Line extends Omit<
  IMultiColumnsItemProps,
  'children'
> {
  children?: React.ReactNode
  labels?: ILabelGroupTemplate3MaxLabels6Props['list']
  text: string
  more?: boolean
  textStars?: string
  textDirectors?: string
  episodePopup?: ITVShowPopupProps['title']
  titlePopup?: ITVShowPopupProps['description']
  labelsPopup?: ITVShowPopupProps['labels']
  listPopup?: ITVShowPopupProps['list']
  directorsPopup?: ITVShowPopupProps['directors']
  starsPopup?: ITVShowPopupProps['stars']
  titleButton?: string
  fullInformation?: boolean
  popupWidth?: string
  withUsingPortal?: boolean
  directors?: string
  stars?: string
  onClickMore?: (args: any) => void
}

export const LabelsGroupDescription4Line = ({
  labels,
  text,
  rowGap = MultiColumnsRowGap.INDENT_20,
  children,
  more,
  textDirectors = '',
  textStars = '',
  episodePopup,
  titlePopup,
  labelsPopup,
  listPopup,
  titleButton,
  fullInformation,
  popupWidth,
  withUsingPortal,
  starsPopup,
  directorsPopup,
  directors: _unused1,
  stars: _unused2,
  onClickMore,
  ...rest
}: ILabelsGroupDescription4Line) => {
  return (
    <MultiColumnsItem rowGap={rowGap} {...rest}>
      {labels && <LabelGroupTemplate3MaxLabels6 list={labels} />}
      {more && (
        <TextBlockWithMore
          description={text}
          stars={textStars}
          directors={textDirectors}
          episodePopup={episodePopup}
          titlePopup={titlePopup}
          labelsPopup={labelsPopup}
          listPopup={listPopup}
          starsPopup={starsPopup}
          directorsPopup={directorsPopup}
          titleButton={titleButton}
          fullInformation={fullInformation}
          popupWidth={popupWidth}
          withUsingPortal={withUsingPortal}
          onClickMore={onClickMore}
          maxLines={4}
        />
      )}
      {text && !more && (
        <TextBoxMaxLine4Body3 preWrap>{text}</TextBoxMaxLine4Body3>
      )}
      {children}
    </MultiColumnsItem>
  )
}
